var _mask, _path, _path2, _mask2, _path3, _mask3, _path4, _mask4, _path5, _mask5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcamBorderPortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 391,
    viewBox: "0 0 218 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13075_56369",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.95431 12.9543 0 24 0H194C205.046 0 214 8.95431 214 20V371C214 382.046 205.046 391 194 391H24C12.9543 391 4 382.046 4 371V20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.95431 12.9543 0 24 0H194C205.046 0 214 8.95431 214 20V371C214 382.046 205.046 391 194 391H24C12.9543 391 4 382.046 4 371V20Z",
    fill: "url(#pattern0_13075_56369)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0V4H194V0V-4H24V0ZM214 20H210V371H214H218V20H214ZM194 391V387H24V391V395H194V391ZM4 371H8V20H4H0V371H4ZM24 391V387C15.1634 387 8 379.837 8 371H4H0C0 384.255 10.7452 395 24 395V391ZM214 371H210C210 379.837 202.837 387 194 387V391V395C207.255 395 218 384.255 218 371H214ZM194 0V4C202.837 4 210 11.1634 210 20H214H218C218 6.74517 207.255 -4 194 -4V0ZM24 0V-4C10.7452 -4 0 6.74518 0 20H4H8C8 11.1635 15.1634 4 24 4V0Z",
    fill: "white",
    mask: "url(#path-1-inside-1_13075_56369)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13075_56369",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.95431 12.9543 0 24 0H52V48H4V20Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 6.74517 10.7452 -4 24 -4H52V4H24C15.1634 4 8 11.1634 8 20H0ZM52 48H4H52ZM0 48V20C0 6.74517 10.7452 -4 24 -4V4C15.1634 4 8 11.1634 8 20V48H0ZM52 0V48V0Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13075_56369)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13075_56369",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 0H194C205.046 0 214 8.9543 214 20V48H166V0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166 -4H194C207.255 -4 218 6.74517 218 20H210C210 11.1634 202.837 4 194 4H166V-4ZM214 48H166H214ZM166 48V0V48ZM194 -4C207.255 -4 218 6.74517 218 20V48H210V20C210 11.1634 202.837 4 194 4V-4Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13075_56369)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13075_56369",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 343H52V391H24C12.9543 391 4 382.046 4 371V343Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 343H52H4ZM52 395H24C10.7452 395 0 384.255 0 371H8C8 379.837 15.1634 387 24 387H52V395ZM24 395C10.7452 395 0 384.255 0 371V343H8V371C8 379.837 15.1634 387 24 387V395ZM52 343V391V343Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13075_56369)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13075_56369",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 343H214V371C214 382.046 205.046 391 194 391H166V343Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166 343H214H166ZM218 371C218 384.255 207.255 395 194 395H166V387H194C202.837 387 210 379.837 210 371H218ZM166 391V343V391ZM218 343V371C218 384.255 207.255 395 194 395V387C202.837 387 210 379.837 210 371V343H218Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13075_56369)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13075_56369)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamBorderPortrait);
export default __webpack_public_path__ + "static/media/webcam_border_portrait.522fba76ff804b99c8875f415929586d.svg";
export { ForwardRef as ReactComponent };